(() => {
  const locale = (document.documentElement.lang || navigator.language || 'fr').toLowerCase().split('-')[0];
  if (locale !== 'fr') return;

  const exact = new Map(Object.entries({
    'thighs, glutes and calves when you want broad, rhythmic coverage.':'cuisses, fessiers et mollets lorsque vous recherchez une couverture large et rythmée.',
    'Roll slowly back and forth. Start light and let the tool stay flat against the skin.':'Faites rouler lentement d’avant en arrière. Commencez doucement et gardez l’outil bien à plat contre la peau.',
    'thighs, calves and upper arms when you prefer a more textured rolling sensation.':'cuisses, mollets et haut des bras lorsque vous préférez une sensation de roulement plus texturée.',
    'Use short, repeated passes with light pressure. Avoid rolling directly over bony areas.':'Effectuez des passages courts et répétés avec une pression légère. Évitez de rouler directement sur les zones osseuses.',
    'legs and curved areas where a rigid roller feels less natural.':'jambes et zones courbes où un rouleau rigide paraît moins naturel.',
    'Keep the movement long and unhurried. Let the flexible discs follow the body instead of forcing the curve.':'Gardez un mouvement long et lent. Laissez les disques flexibles suivre le corps sans forcer la courbe.',
    'smaller fleshy areas when you want a compact rolling tool that is easy to control.':'petites zones charnues lorsque vous voulez un outil compact et facile à contrôler.',
    'Use slow, short passes and keep the pressure gentle until you know what feels comfortable.':'Effectuez des passages courts et lents, avec une pression douce jusqu’à trouver ce qui vous convient.',
    'thighs, hips and upper arms when you want a guided contouring movement.':'cuisses, hanches et haut des bras lorsque vous souhaitez un mouvement de contour guidé.',
    'Hold the handle comfortably and use long, slow strokes. Keep the movement smooth rather than forcing pressure.':'Tenez la poignée confortablement et effectuez de longs gestes lents. Privilégiez la fluidité plutôt que la force.',
    'outer thighs, hips and arms when you want a wider surface for long passes.':'extérieur des cuisses, hanches et bras lorsque vous souhaitez une surface plus large pour de longs passages.',
    'Keep the broad edge flat and move in one controlled direction at a time.':'Gardez le bord large à plat et avancez dans une direction contrôlée à la fois.',
    'outer thighs, hips and upper arms when you want a smaller contour tool with a precise edge.':'extérieur des cuisses, hanches et haut des bras lorsque vous souhaitez un outil de contour plus compact et précis.',
    'Use the curved edge to guide a slow, deliberate glide. Keep pressure comfortable.':'Utilisez le bord courbé pour guider une glisse lente et maîtrisée. Gardez une pression confortable.',
    'shoulders, arms and calves when you want a palm-controlled tool for smaller areas.':'épaules, bras et mollets lorsque vous voulez un outil contrôlé à la paume pour les petites zones.',
    'Rest it in your palm and use small, slow circles or short passes. Use broad, comfortable pressure.':'Placez-le dans la paume et effectuez de petits cercles lents ou de courts passages. Utilisez une pression large et confortable.',
    'thighs, glutes and upper arms when you want an easy one-hand massage shape.':'cuisses, fessiers et haut des bras lorsque vous recherchez une forme facile à utiliser d’une seule main.',
    'Hold the cup in your palm and use slow circles or short passes. Start light and adjust gradually.':'Tenez la cup dans la paume et effectuez des cercles lents ou de courts passages. Commencez doucement puis ajustez progressivement.',
    'Warm, tactile forms that feel at home in an intentional body-care routine.':'Des formes chaleureuses et tactiles, pensées pour s’intégrer naturellement à une routine de soin du corps.',
    'Broad rhythmic rolling':'Roulement large et rythmé',
    'Textured rolling':'Roulement texturé',
    'Flexible body rolling':'Roulement flexible',
    'Focused rolling':'Roulement ciblé',
    'Everyday contour glide':'Glisse contour quotidienne',
    'Long controlled glide':'Glisse longue et contrôlée',
    'Precision glide':'Glisse de précision',
    'Palm-controlled pressure':'Pression contrôlée à la paume',
    'One-hand massage':'Massage à une main',
    'Bundle size':'Nombre de pièces',
    'Selected tools':'Outils sélectionnés',
    'Pieces':'Pièces',
    'AUREKO Build Your Wood Therapy Ritual — Choose Your Tools':'AUREKO — Composez votre rituel de madérothérapie',
    'Build Your Wood Therapy Ritual':'Composez votre rituel de madérothérapie',
    'Wood Therapy Massage Set':'Kit de madérothérapie',
    'AUREKO Wood Therapy Massage Set':'Kit de madérothérapie AUREKO',
    'Secure checkout powered by Shopify':'Paiement sécurisé par Shopify',
    'Clear returns policy and customer support':'Politique de retour claire et service client',
    'Choose your bundle':'Choisissez votre bundle',
    'Choose your tools':'Choisissez vos outils',
    'Choose tools':'Choisir les outils',
    'Your selection':'Votre sélection',
    'Your bundle':'Votre bundle',
    'Bundle':'Bundle',
    'Included':'Inclus',
    'Complimentary':'Offert',
    'Massage Oil':'Huile de massage',
    'Natural Massage Oil':'Huile de massage naturelle',
    'Natural body care':'Soin du corps naturel',
    'At-home body care':'Soin du corps à la maison',
    'French-inspired wellness':'Bien-être d’inspiration française',
    'Secure payment':'Paiement sécurisé',
    'Secure payments':'Paiements sécurisés',
    'Free oil':'Huile offerte',
    'Free massage oil':'Huile de massage offerte',
    'Learn more':'En savoir plus',
    'View details':'Voir les détails',
    'View product':'Voir le produit',
    'Continue shopping':'Continuer mes achats',
    'Checkout':'Paiement',
    'Remove':'Supprimer',
    'Decrease quantity':'Diminuer la quantité',
    'Increase quantity':'Augmenter la quantité',
    'Product image':'Image du produit',
    'Previous image':'Image précédente',
    'Next image':'Image suivante',
    'Select option':'Choisir une option',
    'Choose an option':'Choisissez une option',
    'In stock':'En stock',
    'Out of stock':'Rupture de stock',
    'Sale':'Promotion',
    'Regular price':'Prix habituel',
    'Compare at price':'Prix de comparaison',
    'Price':'Prix',
    'Total':'Total',
    'Estimated total':'Total estimé',
    'Order summary':'Récapitulatif de la commande',
    'Taxes included.':'Taxes incluses.',
    'Shipping calculated at checkout.':'Livraison calculée lors du paiement.',
    'Taxes and shipping calculated at checkout.':'Taxes et livraison calculées lors du paiement.',
    'Discount':'Réduction',
    'Discounts':'Réductions',
    'Apply':'Appliquer',
    'Your cart':'Votre panier',
    'Shopping cart':'Panier',
    'Cart total':'Total du panier',
    'Continue to checkout':'Continuer vers le paiement',
    'Secure checkout':'Paiement sécurisé',
    'Customer support':'Service client',
    'Returns policy':'Politique de retour',
    'Shipping policy':'Politique de livraison',
    'Privacy policy':'Politique de confidentialité',
    'Terms of service':'Conditions générales',
    'Contact us':'Nous contacter'
  }));

  const toolNames = [
    'Disc Body Roller','Cubed Body Roller','Flex Disc Roller','Roller Massage Cup',
    'Y Contour Sculptor','Contour Body Board','Sculpting Curve','Massage Mushroom','Wood Massage Cup'
  ];

  const norm = s => String(s || '').replace(/\s+/g, ' ').trim();

  function dynamic(text) {
    let m;
    if ((m = text.match(/^Bag\s*\((\d+)\)$/i))) return `Panier (${m[1]})`;
    if ((m = text.match(/^(\d+) Pieces\s*[·•—-]\s*(.+)$/i))) return `${m[1]} pièces · ${m[2]}`;
    if ((m = text.match(/^(\d+) Pieces\s+(.+)$/i)) && /[$€£CHF]|\d/.test(m[2])) return `${m[1]} pièces ${m[2]}`;
    if ((m = text.match(/^Remove\s+(.+)$/i))) return `Supprimer ${m[1]}`;
    if ((m = text.match(/^Add\s+(Disc Body Roller|Cubed Body Roller|Flex Disc Roller|Roller Massage Cup|Y Contour Sculptor|Contour Body Board|Sculpting Curve|Massage Mushroom|Wood Massage Cup)$/i))) return `Ajouter ${m[1]}`;
    if ((m = text.match(/^Select\s+(Disc Body Roller|Cubed Body Roller|Flex Disc Roller|Roller Massage Cup|Y Contour Sculptor|Contour Body Board|Sculpting Curve|Massage Mushroom|Wood Massage Cup)$/i))) return `Sélectionner ${m[1]}`;
    if ((m = text.match(/^Deselect\s+(.+)$/i))) return `Désélectionner ${m[1]}`;
    if ((m = text.match(/^Add (\d+) (piece|pieces)$/i))) return `Ajouter ${m[1]} ${Number(m[1]) === 1 ? 'pièce' : 'pièces'}`;
    if ((m = text.match(/^Choose (\d+) (piece|pieces)$/i))) return `Choisir ${m[1]} ${Number(m[1]) === 1 ? 'pièce' : 'pièces'}`;
    if ((m = text.match(/^([0-9]+) piece bundle$/i))) return `Bundle ${m[1]} pièces`;
    if ((m = text.match(/^([0-9]+)-piece bundle$/i))) return `Bundle ${m[1]} pièces`;
    if ((m = text.match(/^([0-9]+) pieces selected$/i))) return `${m[1]} pièces sélectionnées`;
    if ((m = text.match(/^Only (\d+) left$/i))) return `Plus que ${m[1]} en stock`;
    if ((m = text.match(/^You save\s+(.+)$/i))) return `Vous économisez ${m[1]}`;
    if ((m = text.match(/^Save\s+(.+)$/i))) return `Économisez ${m[1]}`;
    if ((m = text.match(/^From\s+(.+)$/i))) return `À partir de ${m[1]}`;
    if ((m = text.match(/^Add to cart\s*[·•—-]\s*(.+)$/i))) return `Ajouter au panier · ${m[1]}`;
    if ((m = text.match(/^Add to bag\s*[·•—-]\s*(.+)$/i))) return `Ajouter au panier · ${m[1]}`;
    return null;
  }

  function translateValue(value) {
    const key = norm(value);
    if (!key) return null;
    return exact.get(key) || dynamic(key) || null;
  }

  const skip = new Set(['SCRIPT','STYLE','NOSCRIPT','TEXTAREA','CODE','PRE']);

  function translateText(node) {
    if (!node || !node.parentElement || skip.has(node.parentElement.tagName)) return;
    const raw = node.nodeValue;
    const out = translateValue(raw);
    if (!out) return;
    const lead = raw.match(/^\s*/)?.[0] || '';
    const trail = raw.match(/\s*$/)?.[0] || '';
    node.nodeValue = lead + out + trail;
  }

  function translateAttrs(el) {
    if (!(el instanceof Element) || skip.has(el.tagName)) return;
    ['aria-label','placeholder','title','data-label'].forEach(attr => {
      if (!el.hasAttribute(attr)) return;
      const raw = el.getAttribute(attr);
      const out = translateValue(raw);
      if (out) el.setAttribute(attr, out);
    });
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) return translateText(root);
    if (![Node.ELEMENT_NODE, Node.DOCUMENT_FRAGMENT_NODE, Node.DOCUMENT_NODE].includes(root.nodeType)) return;
    if (root.nodeType === Node.ELEMENT_NODE) translateAttrs(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, {
      acceptNode(node) {
        if (node.nodeType === Node.ELEMENT_NODE && skip.has(node.tagName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === Node.TEXT_NODE) translateText(node);
      else translateAttrs(node);
    }
  }

  function init() {
    walk(document.body);
    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') translateText(mutation.target);
        mutation.addedNodes.forEach(walk);
        if (mutation.type === 'attributes') translateAttrs(mutation.target);
      }
    });
    observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label','placeholder','title','data-label'] });
    [120, 350, 800, 1600, 3000, 5500].forEach(ms => setTimeout(() => walk(document.body), ms));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
